import { Component, OnInit } from '@angular/core';
import { WebsiteService } from 'src/app/Services/website.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  
  contact:any = {};
  formData:FormData = new FormData();

  constructor(private websiteser: WebsiteService,
    private toastr: ToastrService, private loader: LoaderService) { }

  ngOnInit() {
  }

  submitContact(){
    if(!this.contact.userName || !this.contact.email 
      || !this.contact.subject || !this.contact.message 
      ){
        return;
      }
    this.loader.showLoader();
    this.formData.append('message', JSON.stringify(this.contact));
    // this.websiteser.ContactUs(this.contact).subscribe((date) => {
    this.websiteser.ContactUs(this.formData).subscribe((date) => {
      this.toastr.success('Email sent successfully.');
      this.loader.hideLoader();
    },
    (err)=>{
      this.toastr.error(err.Error.Errors[0]);
      this.loader.hideLoader();
    })
  }

  fileChange(event){
    let fileList: FileList = event.target.files;
    //this.formData.append('file', fileList.item(0))

    for (let i = 0; i < fileList.length; i++) {
      this.formData.append('file', fileList[i])
    }
  }

}
